import styled from 'styled-components';
import { Link } from 'gatsby';

export const GlobalLink = styled(Link)`
  display: flex;
  flex-flow: column;
  justify-content: center;
  padding: 0 15px;
  color: #fff;
  opacity: 0.7;
  text-decoration: none;
  background-color: transparent;

  &.is-selected {
    opacity: 1;
    background: #f0f0f0;
    color: #000;

    @media (max-width: 1099px) {
      color: #fff;
      background: none;
    }
  }

  &[dir='ltr'] {
    font-size: 12px;
    letter-spacing: 1.82px !important;
    
    @media (min-width: 1100px) {
      font-size: 10px;
    }
  }

  &[dir='rtl'] {
    font-size: 14px;
  }

  &:hover {
    opacity: 1;
    text-decoration: underline;
  }
`;
